import React, { createContext, useContext, useEffect, useState } from "react";

const DashboardStateContext = createContext();

const DashboardStateProvider = ({ children }) => {
  const [foldersTree, setFoldersTree] = useState(null);
  const [activeFolder, setActiveFolder] = useState(null);
  const [activeProject, setActiveProject] = useState(null);
  const [isFolderLoading, setIsFolderLoading] = useState(false);
  const [favourites, setFavourites] = useState(null);
  const [recent, setRecent] = useState(null);
  const [isTableHidden, setIsTableHidden] = useState(true);
  const [checkSidebarDropdownStatus, setCheckSidebarDropdownStatus] = useState(true);
  const [isModalLoaded, setIsModalLoaded] = useState({ status: false });
  const [isWelcomeModalSeen, setIsWelcomeModalSeen] = useState(false);
  const [signingState, setSigningState] = useState(null);

  useEffect(() => {
    if(!foldersTree || !activeProject || !activeFolder) {
      const breadcrumbsData = JSON.parse(localStorage.getItem('breadcrumbsData'))
      if(breadcrumbsData?.activeProject || breadcrumbsData?.activeFolder || breadcrumbsData?.foldersTree) {
        setActiveProject(breadcrumbsData?.activeProject)
        setActiveFolder(breadcrumbsData?.activeFolder)
        setFoldersTree(breadcrumbsData?.foldersTree)
      }
    }
  }, []);

  return (
    <DashboardStateContext.Provider
      value={{
        foldersTree,
        activeFolder,
        activeProject,
        isFolderLoading,
        favourites,
        recent,
        isTableHidden,
        isModalLoaded,
        checkSidebarDropdownStatus,
        isWelcomeModalSeen,
        signingState, // signinState: 0 - initial state, 1 - after new user form, 2 - after animation
        setFoldersTree,
        setActiveFolder,
        setActiveProject,
        setIsFolderLoading,
        setFavourites,
        setRecent,
        setIsTableHidden,
        setIsModalLoaded,
        setCheckSidebarDropdownStatus,
        setIsWelcomeModalSeen,
        setSigningState,
      }}
    >
      {children}
    </DashboardStateContext.Provider>
  );
};

const useDashboardState = () => useContext(DashboardStateContext);

export { DashboardStateProvider, useDashboardState };
